import { cn } from "@pulsex/utils";
import React from "react";

type SummaryProps = {
  children: React.ReactNode;
  className?: string;
  url?: string;
};

export const Summary = ({ children, className, url }: SummaryProps) => {
  return (
    <>
      <p
        className={cn(
          "w-fit mt-1 cursor-pointer text-base max-sm:py-0 font-noto-arabic line-clamp-5",
          className
        )}
      >
        {children}
      </p>
    </>
  );
};
